import type {
  WebHomePageGetOutputDto,
  WebHomePageGetOutputItemDto,
  WebHomePageGetOutputItemFiltersDto,
  WebHomePageGetOutputItemPaginationDto,
} from '@bldsoft/ovp-api-types'
import { HomeRowType } from '@setplex/tria-api'

export enum ApiHomeRowContentType {
  movie = 'movie',
  tvShow = 'tvShow',
  liveChannel = 'liveChannel',
  mixed = 'mixed',
}

export enum ApiHomeRowMixedType {
  content = 'content',
  tvshow = 'tv_show',
}

export type ApiHomeRows = WebHomePageGetOutputDto

export type ApiHomeRow = WebHomePageGetOutputItemDto & {
  rowContentType: ApiHomeRowContentType | string
  rowEntityType: HomeRowType | string
  filters?: WebHomePageGetOutputItemFiltersDto
  order?: WebHomePageGetOutputItemPaginationDto
}
